<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="矿业信息列表" name="1">
      <KyxxAdd :updataID='updataID'></KyxxAdd>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * 矿业信息修改
 */
import KyxxAdd from '../../../../static/form/KyxxAdd.vue'
export default {
  components: {
    KyxxAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/KyxxMap'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/KyxxUpdate.vue